import React, { useState } from 'react';
import Button from '../Button';
import Icon from '../Icon';
import { Menu, MenuForm, MenuItem, MenuSeparator } from '../Menu';
import { SORT_COLUMNS } from '../../hooks/useExpenseList';
import s from './ExpenseToolbar.module.css';
import { DecimalInput } from '../RegionInputs';

// Add New, Actions, Sort and Search.
//
// All control, no display: every element here exists to change what the table
// below shows, or to open something. It holds only which of its own menus is
// open — the sort and filter values belong to the list.
export default function ExpenseToolbar({
  onAddNew,
  onCategories,
  onImport,
  sort,
  onSortBy,
  onClearSort,
  draft,
  onDraftChange,
  onApplyFilter,
  onClearFilter,
  categories,
}) {
  const [open, setOpen] = useState(null); // null | 'actions' | 'sort' | 'search'
  // By Amount is typed in the Region (`DecimalInput`, #526). What a third
  // decimal *does* to the value is decided in `setDraft`, in
  // src/hooks/useExpenseList.js (#308).
  const toggle = (which) => setOpen((cur) => (cur === which ? null : which));
  const close = () => setOpen(null);

  const arrow = (key) => (sort.key === key ? (sort.desc ? ' ↓' : ' ↑') : '');

  return (
    <div className={s.bar}>
      <Button onClick={onAddNew}>+ Add New</Button>

      <Menu
        open={open === 'actions'}
        onClose={close}
        align="left"
        panelClassName={s.wide}
        trigger={(
          <Button variant="secondary" onClick={() => toggle('actions')}>
            <span className={s.withIcon}><Icon name="gear" />Actions ▾</span>
          </Button>
        )}
      >
        <MenuItem icon="tag" onClick={() => { close(); onCategories(); }}>Categories</MenuItem>
        <MenuItem icon="upload" onClick={() => { close(); onImport(); }}>
          Import Expenses &amp; Other Revenue
        </MenuItem>
      </Menu>

      <span className={s.spacer} />

      <Menu
        open={open === 'sort'}
        onClose={close}
        trigger={<Button variant="secondary" onClick={() => toggle('sort')}>Sort ▾</Button>}
      >
        <MenuItem accent onClick={() => { onClearSort(); close(); }}>Clear Sort</MenuItem>
        <MenuSeparator />
        {SORT_COLUMNS.map((c) => (
          <MenuItem key={c.key} onClick={() => { onSortBy(c.key); close(); }}>
            {c.label}{arrow(c.key)}
          </MenuItem>
        ))}
      </Menu>

      <MenuForm
        open={open === 'search'}
        onClose={close}
        trigger={<Button variant="secondary" onClick={() => toggle('search')}>Search ▾</Button>}
      >
        <input
          className={s.field}
          placeholder="Search by payee/payer"
          value={draft.text}
          onChange={(e) => onDraftChange({ ...draft, text: e.target.value })}
        />
        <div className={s.label}>By Category</div>
        <select
          className={`${s.field} ${s.spaced}`}
          value={draft.category}
          onChange={(e) => onDraftChange({ ...draft, category: e.target.value })}
        >
          <option value="">Select</option>
          {categories.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <div className={s.label}>By Amount</div>
        <DecimalInput
          className={`${s.field} ${s.spaced}`}
          placeholder="0.00"
          value={draft.amount}
          onChange={(e) => onDraftChange({ ...draft, amount: e.target.value })}
        />
        <div className={s.rule} />
        <div className={s.actions}>
          <Button variant="secondary" onClick={() => { onClearFilter(); close(); }}>Clear</Button>
          <Button onClick={() => { onApplyFilter(draft); close(); }}>Search</Button>
        </div>
      </MenuForm>
    </div>
  );
}
